let initialState = {}
let obj = 
{
    visited:false,
    answered:false,
    flagged:false,
}

const AnswersReducer = (state=initialState,action) => {
    switch(action.type)
    {
        case 'SET_ANSWERS':
            {
                state[action.payload.index]=action.payload;
                state['lastUpdatedIndex']=action.payload.index;
                state['lastUpdatedSectionIndex']=action.payload.lastUpdatedSectionIndex;
                return {...state};
            }
        case 'SET_ALL_ANSWERS':
            {
                state = action.payload
                return {...state};
            }
        case 'CLEAR_ANSWERS':
            {
                state={}
                return {...state};
            }
        default:
             return state;
    }
}

export default AnswersReducer;